<p>an exception was thrown in ngInit and should make it to rollbar (if not running on localhost)</p>
